import { useEffect, useState } from "react";
import api from "../api";
import { Modal } from "./ui";

export default function MergeContacts({ onClose }) {
  const [type, setType] = useState("aziende");
  const [companies, setCompanies] = useState([]);
  const [persons, setPersons] = useState([]);
  const [primary, setPrimary] = useState("");
  const [duplicate, setDuplicate] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    api.get("/companies").then((r) => setCompanies(r.data)).catch(() => {});
    api.get("/persons").then((r) => setPersons(r.data)).catch(() => {});
  }, []);

  const options = type === "aziende"
    ? companies.map((c) => ({ id: c.id, label: `${c.name}${c.email ? " · " + c.email : ""}` }))
    : persons.map((p) => ({ id: p.id, label: `${p.last_name || ""} ${p.first_name || ""}${p.email ? " · " + p.email : ""}`.trim() }));
  const sorted = [...options].sort((a, b) => a.label.localeCompare(b.label, "it"));
  const nameOf = (id) => options.find((o) => o.id === id)?.label || "";

  const run = async () => {
    if (!primary || !duplicate) { setMsg("Scegli entrambe le schede."); return; }
    if (primary === duplicate) { setMsg("Le due schede coincidono."); return; }
    if (!window.confirm(`Confermi?\n\n✔ TENGO: ${nameOf(primary)}\n✖ UNISCO ED ELIMINO: ${nameOf(duplicate)}\n\nEmail/telefoni del doppione non presenti sulla scheda principale verranno salvati (campi vuoti riempiti, il resto nelle note). Tutto lo storico verrà spostato. L'operazione non è annullabile.`)) return;
    setBusy(true); setMsg("");
    try {
      const url = type === "aziende" ? "/companies/merge" : "/persons/merge";
      const r = await api.post(url, { primary_id: primary, duplicate_id: duplicate });
      const moved = Object.entries(r.data.moved || {}).map(([k, v]) => `${k}: ${v}`).join(", ");
      alert(`Unificazione completata.${moved ? `\nElementi spostati → ${moved}` : ""}${r.data.extra_in_notes?.length ? `\nContatti extra salvati nelle note: ${r.data.extra_in_notes.join(" · ")}` : ""}`);
      window.location.reload();
    } catch (e) { setMsg("Errore: " + (e.response?.data?.detail || e.message)); }
    setBusy(false);
  };

  return (
    <Modal title="🔀 Unifica doppioni" onClose={onClose}>
      <p className="muted" style={{ marginTop: 0, fontSize: 13 }}>
        Scegli la scheda da <strong>tenere</strong> e il <strong>doppione</strong> da unire: email, telefoni, etichette e
        tutto lo storico (email, WhatsApp, progetti, fatture, F24, appuntamenti) verranno riversati sulla scheda
        principale, poi il doppione viene eliminato.
      </p>
      <label>Tipo</label>
      <select value={type} onChange={(e) => { setType(e.target.value); setPrimary(""); setDuplicate(""); }} data-testid="merge-type">
        <option value="aziende">Aziende</option>
        <option value="persone">Persone</option>
      </select>
      <label style={{ marginTop: 8 }}>✔ Scheda da tenere</label>
      <select value={primary} onChange={(e) => setPrimary(e.target.value)} data-testid="merge-primary">
        <option value="">— scegli —</option>
        {sorted.map((o) => <option key={o.id} value={o.id}>{o.label}</option>)}
      </select>
      <label style={{ marginTop: 8 }}>✖ Doppione da unire ed eliminare</label>
      <select value={duplicate} onChange={(e) => setDuplicate(e.target.value)} data-testid="merge-duplicate">
        <option value="">— scegli —</option>
        {sorted.filter((o) => o.id !== primary).map((o) => <option key={o.id} value={o.id}>{o.label}</option>)}
      </select>
      {msg && <p style={{ color: "#f87171", fontSize: 13 }}>{msg}</p>}
      <div className="toolbar" style={{ marginTop: 14 }}>
        <button className="btn primary" onClick={run} disabled={busy} data-testid="merge-confirm">{busy ? "Unifico…" : "Unifica"}</button>
        <button className="btn" onClick={onClose}>Annulla</button>
      </div>
    </Modal>
  );
}
